import React from "react";

interface ProgressMessageProps {
  progressMessage: string;
}

const ProgressMessage: React.FC<ProgressMessageProps> = ({ progressMessage, }) => {

  return (
    <div
      className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
      style={{ backgroundColor: 'rgba(255, 255, 255, 0.8)', zIndex: 9999 }}
    >
      <div className="text-center">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="mt-2 small text-dark">{progressMessage}</p> {/* Replace with {progressMessage} if needed */}
      </div>
    </div>

  );
};

export default ProgressMessage;
